import { APIModel } from "../api-model";
import { AssociatedUser } from "../associated-user";
import { TagCategory } from "./tag-category";

export class Tag extends APIModel {
  id!: string;
  name!: string;
  created_by!: AssociatedUser;
  updated_by!: AssociatedUser;
  disabled_by!: AssociatedUser;
  disabled_at!: string;
  disabled_by_id!: string;
  tag_category!: TagCategory;

  static fieldsToMap = {
    direct: [
      'id',
      'name',
      'disabled_at',
      'disabled_by_id'
    ]
  }

  static buildFromAPI(record: any): Tag {
    const row = new Tag();
    record = record || {};

    this.mapFieldsDirectly<Tag>(Tag.fieldsToMap.direct, record, row);

    row.created_by = AssociatedUser.buildFromAPI(record.created_by);
    row.updated_by = AssociatedUser.buildFromAPI(record.updated_by);
    row.disabled_by = AssociatedUser.buildFromAPI(record.disabled_by);
    row.tag_category = TagCategory.buildFromAPI(record.tag_category);

    return row;
  }

  get state(): string {
    return this.disabled_at ? 'Disabled' : 'Enabled'
  }
}